export const mockUsers = [
    { id: 1, name: 'Devansh Jain', email: 'dev@gmail.com', role: 'Admin', status: 'Active' },
    { id: 2, name: 'Test', email: 'test@gmail.com', role: 'Editor', status: 'Inactive' },
  ];
  
  export const mockRoles = [
    { id: 1, name: 'Admin', description: 'Full access to the system' },
    { id: 2, name: 'Editor', description: 'Can edit content' },
    { id: 3, name: 'Viewer', description: 'Can read content' },
  ];
  
  export const mockPermissions = [
    { roleId: 1, name: 'Admin', permissions: ['Read', 'Write', 'Delete'] },
    { roleId: 2, name: 'Editor', permissions: ['Read', 'Write'] },
    { roleId: 3, name: 'Viewer', permissions: ['Read'] },
  ];
  